import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

import { push } from "react-router-redux";

function* handleRoute(action) {
  yield put(push(action.path));
}

export function* routeWatcher() {
  yield takeEvery(ACTIONS.RE_ROUTE, handleRoute);
}



// WEBPACK FOOTER //
// ./src/sagas/router.js